import React, { FC } from "react";

import { Route, Routes as ReactRoutes } from "react-router-dom";

import {
    CookiePolicyPage,
    InviteFromBroker,
    InviteFromBrokerInfo,
    ItsMe,
    ItsMeActivateAccount,
    ItsMeRegister,
    Login,
    PrivacyPolicyPage,
    RegisterPassword,
    ResetPassword,
    TermsOfUsePage,
} from "@/components/features";

import { RedirectComponent } from "./components/organisms";
import ErrorPage from "./components/pages/ErrorPage/ErrorPage";
import { DebugRouter } from "./Routes";
import { AppRoute } from "./shared/domain";

const Register = React.lazy(() => import("./components/features/Authentication/Register/Register"));
const ReportSchoolClaimPage = React.lazy(
    () => import("./components/features/ReportDamage/ReportSchoolClaimPage/ReportSchoolClaimPage"),
);

export const RoutesPublic: FC = () => {
    return (
        <DebugRouter>
            <ReactRoutes>
                <Route path={AppRoute.Register} element={<Register />} />
                <Route path={AppRoute.RegisterWithToken} element={<RegisterPassword />} />
                <Route path={AppRoute.Invite} element={<InviteFromBrokerInfo />} />
                <Route path={AppRoute.InviteWithToken} element={<InviteFromBroker />} />
                <Route path={AppRoute.ResetPassword} element={<ResetPassword />} />
                <Route path={AppRoute.ResetPasswordWithToken} element={<ResetPassword />} />
                <Route path={AppRoute.Itsme} element={<ItsMe />} />
                <Route path={AppRoute.ItsmeRegister} element={<ItsMeRegister />} />
                <Route path={AppRoute.ItsmeActivation} element={<ItsMeActivateAccount />} />
                <Route path={AppRoute.CookiePolicy} element={<CookiePolicyPage />} />
                <Route path={AppRoute.PrivacyPolicy} element={<PrivacyPolicyPage />} />
                <Route path={AppRoute.TermsOfUse} element={<TermsOfUsePage />} />
                <Route path={AppRoute.Error} element={<ErrorPage />} />
                <Route path={AppRoute.Root} element={<Login />} />
                <Route path={AppRoute.ReportSchoolDamage} element={<ReportSchoolClaimPage />} />
                <Route path="*" element={<RedirectComponent />} />
                CookieNotice
            </ReactRoutes>
        </DebugRouter>
    );
};
